module.exports = __webpack_public_path__ + "static/media/App.94c7a47b.scss";


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 285
// module chunks = 1